import debounce from "lodash.debounce";
import React from "react";
import { useCallback, useState } from "react";
import styled from "styled-components";

import { InputSearch } from "../../../components";

const StyledInputSearch = styled(InputSearch)`
  width: 100%;
  min-width: 100px;
  max-width: 360px;
  margin-right: 8px;
`;

type Props = {
  initialSearch: string;
  onChange: (search: string) => void;
};

export const DebouncedSearchInput: React.FC<Props> = ({ initialSearch, onChange }) => {
  const [search, setSearch] = useState(initialSearch);

  const onSearchChangeDebounced = useCallback(debounce(onChange, 1_000), []);

  return (
    <StyledInputSearch
      onChange={e => {
        setSearch(e.target.value);
        onSearchChangeDebounced(e.target.value);
      }}
      onKeyDown={e => {
        if (e.key === "Enter") {
          onChange(search);
          onSearchChangeDebounced.cancel();
        }
      }}
      value={search}
    />
  );
};
